export const GET_USER_TRANSACTIONS = /* GraphQL */ `
  query getUserTransactions {
    getUserTransactions {
      boughtSaddles {
        id
        buyerId
        brandName
        createdAt
        isCancelRequestSent
        isRefundRequestSent
        orderId
        orderStatus {
          status
          timestamp
        }
        paymentStatus
        productId
        receiptUrl
        sellerId
        state
        totalPrice
        productPrice
        source
        poRoutingTag
        shopify {
          orderId
          orderDate
          fulfillmentStatus
          tags
        }
      }
      
      soldSaddles {
        id
        buyerId
        brandName
        createdAt
        isCancelRequestSent
        isRefundRequestSent
        orderId
        orderStatus {
          status
          timestamp
        }
        paymentStatus
        productId
        receiptUrl
        sellerId
        state
        totalPrice
        productPrice
        source
        poRoutingTag
        shopify {
          orderId
          orderDate
          fulfillmentStatus
          tags
        }
      }
    }
  }
`;